import { Sys, Sys_query } from './SysCM';
import * as RichTextCM from "./RichTextCM";

export const typeName: string = 'BookingAlert';

export interface BookingAlert {
    __typename: string;
    internalName: string;
    alertText: RichTextCM.RichText;
    sys: Sys;
}

export const query = `
__typename
internalName
alertText {
  ${RichTextCM.query}
}
${Sys_query}
`;
